import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {formatDate} from '../../../../helpers/utils';
import IconLink from '../../../../common/components/link/IconLink';

class LocationCustomerDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visibleWorkOrder: null
		}
	}

	toggleWorkOrderDetail = (workOrderId) => {
		this.setState((prevState) => ({
			visibleWorkOrder: prevState.visibleWorkOrder !== workOrderId ? workOrderId : null
		}));
	};

	render() {
		const {visibleWorkOrder} = this.state;
		const {state: parentState, permissionNames, translate, enableViewInspection} = this.props;
		const {
			totalOpenWorkOrders, workOrders,
			inspections, inspectionsLast3days, inspectionsLast7days,
			partInspections, partInspectionsLast3days, partInspectionsLast7days
		} = parentState;

		return (
			<Fragment>
				<div className='row'>
					<div className='col-sm-12'>
						<div className="small-box bg-teal-active">
							<div className="inner text-center">
								<p>{translate('dashboard_page_location_customer_total_open_work_orders')}</p>
								<h3>{totalOpenWorkOrders}</h3>
							</div>
							<div className="icon">
								<i className="fa fa-book"/>
							</div>
						</div>
					</div>
				</div>

				{
					workOrders.length > 0 && (
						<div className="row">
							<div className="col-sm-12">
								<div className="box">
									<div className="box-body with-top-padding">
										<div className="small-box bg-purple">
											<div className="inner text-center">
												<h4>{translate('dashboard_page_location_customer_activity_work_order')}</h4>
											</div>
										</div>

										<div className="table-responsive">
											<table className="table table-bordered text-center">
												<thead>
												<tr style={{backgroundColor: '#52b9e9', color: 'white'}}>
													<th colSpan={6}/>
													<th colSpan={2}>{translate('dashboard_page_location_customer_activity_last_3_days')}</th>
													<th colSpan={2}>{translate('dashboard_page_location_customer_activity_last_7_days')}</th>
													<th colSpan={2}>{translate('dashboard_page_location_customer_activity_since_start_date')}</th>
												</tr>
												<tr>
													<td colSpan={2} style={{background: '#d9edf7'}}>
														{translate('dashboard_page_location_customer_activity_work_order_code')}
													</td>
													<td className="text-left" style={{background: '#d9edf7'}}>
														{translate('dashboard_page_location_customer_activity_work_order_customer_name')}
													</td>
													<td width="10%" className="text-left" style={{background: '#d9edf7'}}>
														{translate('dashboard_page_location_customer_activity_work_order_job_description')}
													</td>
													<td width="10%" className="text-left" style={{background: '#d9edf7'}}>
														{translate('dashboard_page_location_customer_activity_work_order_clients_information')}
													</td>
													<td style={{background: '#d9edf7'}}>
														{translate('dashboard_page_location_customer_activity_work_order_start_date')}
													</td>
													<td style={{backgroundColor: '#dff0d8'}}>
														{translate('dashboard_page_location_customer_activity_work_order_total_certified')}
													</td>
													<td style={{backgroundColor: '#f2dede'}}>
														{translate('dashboard_page_location_customer_activity_work_order_total_rejected')}
													</td>
													<td style={{backgroundColor: '#dff0d8'}}>
														{translate('dashboard_page_location_customer_activity_work_order_total_certified')}
													</td>
													<td style={{backgroundColor: '#f2dede'}}>
														{translate('dashboard_page_location_customer_activity_work_order_total_rejected')}
													</td>
													<td style={{backgroundColor: '#dff0d8'}}>
														{translate('dashboard_page_location_customer_activity_work_order_total_certified')}
													</td>
													<td style={{backgroundColor: '#f2dede'}}>
														{translate('dashboard_page_location_customer_activity_work_order_total_rejected')}
													</td>
												</tr>
												</thead>
												<tbody>
												{
													workOrders.map((workOrder, index) => {
														const workOrderId = workOrder.id;

														let sumTotalInspected = 0;
														let sumTotalDefect = 0;
														let sumTotalRework = 0;

														let sumTotalCertifiedLast3days = '-';
														let sumTotalRejectedLast3days = '-';
														if (inspectionsLast3days[workOrderId]) {
															sumTotalInspected = parseInt(inspectionsLast3days[workOrderId][0].sum_total_inspected, 10);
															sumTotalDefect = parseInt(inspectionsLast3days[workOrderId][0].sum_total_defect, 10);
															sumTotalRework = parseInt(inspectionsLast3days[workOrderId][0].sum_total_rework, 10);

															sumTotalCertifiedLast3days = sumTotalInspected - sumTotalDefect + sumTotalRework;
															sumTotalRejectedLast3days = sumTotalDefect - sumTotalRework;
														}

														let sumTotalCertifiedLast7days = '-';
														let sumTotalRejectedLast7days = '-';
														if (inspectionsLast7days[workOrderId]) {
															sumTotalInspected = parseInt(inspectionsLast7days[workOrderId][0].sum_total_inspected, 10);
															sumTotalDefect = parseInt(inspectionsLast7days[workOrderId][0].sum_total_defect, 10);
															sumTotalRework = parseInt(inspectionsLast7days[workOrderId][0].sum_total_rework, 10);

															sumTotalCertifiedLast7days = sumTotalInspected - sumTotalDefect + sumTotalRework;
															sumTotalRejectedLast7days = sumTotalDefect - sumTotalRework;
														}

														let sumTotalCertified = '-';
														let sumTotalRejected = '-';
														if (inspections[workOrderId]) {
															sumTotalInspected = parseInt(inspections[workOrderId][0].sum_total_inspected, 10);
															sumTotalDefect = parseInt(inspections[workOrderId][0].sum_total_defect, 10);
															sumTotalRework = parseInt(inspections[workOrderId][0].sum_total_rework, 10);

															sumTotalCertified = sumTotalInspected - sumTotalDefect + sumTotalRework;
															sumTotalRejected = sumTotalDefect - sumTotalRework;
														}

														return (
															<Fragment key={`dashboard_page_location_customer_activity_${index}`}>
																<tr style={{backgroundColor: visibleWorkOrder === workOrderId ? "#f1f1f1" : "#ffffff"}}>
																	<td style={{minWidth: '30px', cursor: 'pointer'}} onClick={(e) => this.toggleWorkOrderDetail(workOrder.id)}>
																		{
																			visibleWorkOrder === workOrderId
																			? <i className="fa fa-angle-down"/>
																			: <i className="fa fa-angle-right"/>
																		}
																	</td>
																	<td>
																		{
																			permissionNames && permissionNames.includes('view_inspection') && enableViewInspection
																				? <IconLink type="link" to={`/inspections/detail/${workOrder.id}`} text={workOrder.code}/>
																				: workOrder.code
																		}
																	</td>
																	<td className="text-left">{workOrder.customer ? workOrder.customer.name : ''}</td>
																	<td className="text-left">{workOrder.job_description}</td>
																	<td className="text-left">{workOrder.clients_information}</td>
																	<td>{formatDate(workOrder.start_date)}</td>
																	<td>{sumTotalCertifiedLast3days}</td>
																	<td>{sumTotalRejectedLast3days}</td>
																	<td>{sumTotalCertifiedLast7days}</td>
																	<td>{sumTotalRejectedLast7days}</td>
																	<td>{sumTotalCertified}</td>
																	<td>{sumTotalRejected}</td>
																</tr>
																{/*{*/}
																{/*	visibleWorkOrder === workOrderId && (*/}
																{/*		<tr style={{backgroundColor: "#f1f1f1"}}>*/}
																{/*			<td colSpan={2}/>*/}
																{/*			<td className="text-left" colSpan={9}>*/}
																{/*				{translate('dashboard_page_location_customer_activity_work_order_job_description') + workOrder.job_description}*/}
																{/*			</td>*/}
																{/*		</tr>*/}
																{/*	)*/}
																{/*}*/}

																{
																	visibleWorkOrder === workOrderId && workOrder.parts.map((part, index2) => {
																		const partId = part.id;

																		let sumTotalInspected = 0;
																		let sumTotalDefect = 0;
																		let sumTotalRework = 0;

																		let sumTotalCertifiedLast3days = '-';
																		let sumTotalRejectedLast3days = '-';
																		if (partInspectionsLast3days[workOrderId] && partInspectionsLast3days[workOrderId][partId]) {
																			sumTotalInspected = parseInt(partInspectionsLast3days[workOrderId][partId][0].sum_total_inspected, 10);
																			sumTotalDefect = parseInt(partInspectionsLast3days[workOrderId][partId][0].sum_total_defect, 10);
																			sumTotalRework = parseInt(partInspectionsLast3days[workOrderId][partId][0].sum_total_rework, 10);

																			sumTotalCertifiedLast3days = sumTotalInspected - sumTotalDefect + sumTotalRework;
																			sumTotalRejectedLast3days = sumTotalDefect - sumTotalRework;
																		}

																		let sumTotalCertifiedLast7days = '-';
																		let sumTotalRejectedLast7days = '-';
																		if (partInspectionsLast7days[workOrderId] && partInspectionsLast7days[workOrderId][partId]) {
																			sumTotalInspected = parseInt(partInspectionsLast7days[workOrderId][partId][0].sum_total_inspected, 10);
																			sumTotalDefect = parseInt(partInspectionsLast7days[workOrderId][partId][0].sum_total_defect, 10);
																			sumTotalRework = parseInt(partInspectionsLast7days[workOrderId][partId][0].sum_total_rework, 10);

																			sumTotalCertifiedLast7days = sumTotalInspected - sumTotalDefect + sumTotalRework;
																			sumTotalRejectedLast7days = sumTotalDefect - sumTotalRework;
																		}

																		let sumTotalCertified = '-';
																		let sumTotalRejected = '-';
																		if (partInspections[workOrderId] && partInspections[workOrderId][partId]) {
																			sumTotalInspected = parseInt(partInspections[workOrderId][partId][0].sum_total_inspected, 10);
																			sumTotalDefect = parseInt(partInspections[workOrderId][partId][0].sum_total_defect, 10);
																			sumTotalRework = parseInt(partInspections[workOrderId][partId][0].sum_total_rework, 10);

																			sumTotalCertified = sumTotalInspected - sumTotalDefect + sumTotalRework;
																			sumTotalRejected = sumTotalDefect - sumTotalRework;
																		}

																		return (
																			<tr style={{backgroundColor: "#f1f1f1"}} key={`dashboard_page_location_customer_activity_${index}_work_order_${index2}`}>
																				<td colSpan={3}/>
																				<td className="text-left" colSpan={3}>
																					{translate('dashboard_page_location_customer_activity_work_order_part_number') + part.number}
																				</td>
																				<td>{sumTotalCertifiedLast3days}</td>
																				<td>{sumTotalRejectedLast3days}</td>
																				<td>{sumTotalCertifiedLast7days}</td>
																				<td>{sumTotalRejectedLast7days}</td>
																				<td>{sumTotalCertified}</td>
																				<td>{sumTotalRejected}</td>
																			</tr>
																		)
																	})
																}
															</Fragment>
														);
													})
												}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					)
				}
			</Fragment>
		);
	}
}

LocationCustomerDashboard.defaultProps = {
	enableViewInspection: true
};

LocationCustomerDashboard.propTypes = {
	state: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired,
	enableViewInspection: PropTypes.bool
};

export default LocationCustomerDashboard;